import React, { useState } from 'react';

interface YouTubeFacadeProps {
    videoId: string;
    title: string;
}

const YouTubeFacade: React.FC<YouTubeFacadeProps> = ({ videoId, title }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    if (isPlaying) {
        return (
            <iframe
                className="w-full h-full"
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1`}
                title={title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
            ></iframe>
        );
    }

    return (
        <div
            className="w-full h-full relative group cursor-pointer overflow-hidden bg-black"
            onClick={() => setIsPlaying(true)}
            aria-label={`Play video: ${title}`}
        >
            {/* Thumbnail */}
            <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                style={{ backgroundImage: `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)` }}
            />

            {/* Overlay */}
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" />

            {/* Play Button */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 md:w-20 md:h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/40 transition-all duration-300 group-hover:scale-110 group-hover:bg-[#FF5C00] group-hover:border-transparent shadow-2xl">
                <svg className="w-6 h-6 md:w-8 md:h-8 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z" />
                </svg>
            </div>

            {/* Title (Optional) */}
            <div className="absolute bottom-6 left-6 right-6 hidden md:block">
                <p className="text-white font-bold text-shadow line-clamp-1">{title}</p>
            </div>
        </div>
    );
};

export default YouTubeFacade;
